/** Resolves SLAS demo asset path for either local or s3 asset loading */
function resolveSlasDemoAssetsPath(relativePath: string, useLocal: boolean): string {
  const hostPrefix = useLocal
    ? '/static'
    : 'https://monomer-slas-demo-cell-images.s3.us-west-2.amazonaws.com'
  return `${hostPrefix}/${relativePath}`
}

export default resolveSlasDemoAssetsPath
